<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import { handleSubmit, parseFormdata, updateNextRoute } from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();

	const handleClick = () => {
		handleSubmit($api_writeForm, parseFormdata($form), redirectRoute);
	};

	let fields = [
		// aotLoyalBeliefs
		{
			labelName: "aot_loyal-beliefs",
			label: "It is important to be loyal to your beliefs even when evidence is brought to bear against them.",
			options: [
				{
					type: "radio",
					value: "1_strongly-disagree", // value/response to send to server
					option: "Strongly disagree", // what to display
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "3_somewhat-disagree",
					option: "Somewhat disagree",
				},
				{
					type: "radio",
					value: "4_somewhat-agree",
					option: "Somewhat agree",
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "6_strongly-agree",
					option: "Strongly agree",
				},
			],
		},
		// aotTrueImportant
		{
			labelName: "aot_true-important",
			label: "Whether something feels true is more important than evidence.",
			options: [
				{
					type: "radio",
					value: "1_strongly-disagree", // value/response to send to server
					option: "Strongly disagree", // what to display
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "3_somewhat-disagree",
					option: "Somewhat disagree",
				},
				{
					type: "radio",
					value: "4_somewhat-agree",
					option: "Somewhat agree",
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "6_strongly-agree",
					option: "Strongly agree",
				},
			],
		},
		// aotEvidenceConflicts
		{
			labelName: "aot_evidence-conflicts",
			label: "Just because evidence conflicts with my current beliefs does not mean my beliefs are wrong.",
			options: [
				{
					type: "radio",
					value: "1_strongly-disagree", // value/response to send to server
					option: "Strongly disagree", // what to display
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "3_somewhat-disagree",
					option: "Somewhat disagree",
				},
				{
					type: "radio",
					value: "4_somewhat-agree",
					option: "Somewhat agree",
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "6_strongly-agree",
					option: "Strongly agree",
				},
			],
		},
		// aotChangeBeliefs
		{
			labelName: "aot_change-beliefs",
			label: "There may be evidence that goes against what you believe but that does not mean you have to change your beliefs.",
			options: [
				{
					type: "radio",
					value: "1_strongly-disagree", // value/response to send to server
					option: "Strongly disagree", // what to display
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "3_somewhat-disagree",
					option: "Somewhat disagree",
				},
				{
					type: "radio",
					value: "4_somewhat-agree",
					option: "Somewhat agree",
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "6_strongly-agree",
					option: "Strongly agree",
				},
			],
		},
		// aotMaintainBeliefs
		{
			labelName: "aot_maintain-beliefs",
			label: "Even if there is concrete evidence against what you believe to be true, it is OK to maintain cherished belief.",
			options: [
				{
					type: "radio",
					value: "1_strongly-disagree", // value/response to send to server
					option: "Strongly disagree", // what to display
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "3_somewhat-disagree",
					option: "Somewhat disagree",
				},
				{
					type: "radio",
					value: "4_somewhat-agree",
					option: "Somewhat agree",
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "6_strongly-agree",
					option: "Strongly agree",
				},
			],
		},
		// aotRegardlessTopic
		{
			labelName: "aot_regardless-topic",
			label: "Regardless of the topic, what you believe to be true is more important than evidence against your beliefs.",
			options: [
				{
					type: "radio",
					value: "1_strongly-disagree", // value/response to send to server
					option: "Strongly disagree", // what to display
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "3_somewhat-disagree",
					option: "Somewhat disagree",
				},
				{
					type: "radio",
					value: "4_somewhat-agree",
					option: "Somewhat agree",
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "6_strongly-agree",
					option: "Strongly agree",
				},
			],
		},


	];

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>How much do you agree or disagree with the following statements?</h1>
	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{@html field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={[required]}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1597px) {
		.option-group {
			display: block;
		}
	}
</style>
